import React from "react";
import { Switch, withRouter } from 'react-router';
import Parameters from "./parameters";
import MarketingListConfig from "./marketingListConfig";
import MarketingListResults from "./marketingListResults";
import { withLocalize } from "react-localize-redux";
import PrivateRoute from '../privateRoute'
import { connect } from "react-redux";
import { popupActions } from "../../store/popupStore";
import { bindActionCreators } from "redux";
import "./unicorn.scss";

class MarketingListLandingPage extends React.Component {
    render() {
        return (
            <div className="marketing-root">
                <Switch>
                    <PrivateRoute exact path={`${this.props.match.url}/parameters`} component={Parameters} permission="MarketingList" />
                    <PrivateRoute exact path={`${this.props.match.url}/configuration`} component={MarketingListConfig} permission="MarketingList" />
                    <PrivateRoute exact path={`${this.props.match.url}/templates`} component={MarketingListResults} />
                    <PrivateRoute exact path={`${this.props.match.url}/results`} component={MarketingListResults} />
                    <PrivateRoute exact path={`${this.props.match.url}/file/:id`} component={MarketingListResults} />
                </Switch>
            </div>
        )
    }
}

export default connect(
    state => state.userContext,
    dispatch => bindActionCreators(popupActions, dispatch))
(withLocalize(withRouter(MarketingListLandingPage)));
